<template>
  <div class="py-24">
    <PaymentMethodFormBase
      ref="selectedPaymentMethodForm"
      :base-price
      :create-payment
      :disabled
      :payment-method
      @setup-error="emit('setup-error', $event)"
      @submit-error="emit('submit-error', $event)"
      @submit-start="emit('submit-start', $event)"
      @submit-success="emit('submit-success', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, toRef } from 'vue'

import type { Price } from '@backmarket/http-api'
import type { PaymentMethod } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'

import type { PaymentFormCreateFunction } from '../../../form-common/types'
import type { PaymentFormExpose } from '../../../form-common/types/PaymentFormInstance'
import type { PaymentMethodFormInstance } from '../../../form-common/types/PaymentMethodFormInstance'
import type { LocalPaymentMethod } from '../../../methods/config/methods.type'
import PaymentMethodFormBase, {
  type PaymentMethodFormBaseEmits,
} from '../PaymentMethodFormBase/PaymentMethodFormBase.vue'

const props = withDefaults(
  defineProps<{
    basePrice: Price
    createPayment: PaymentFormCreateFunction
    disabled?: boolean
    paymentMethod: PaymentMethod | LocalPaymentMethod
  }>(),
  {
    disabled: false,
  },
)

const emit = defineEmits<PaymentMethodFormBaseEmits>()

const paymentMethod = toRef(props, 'paymentMethod')

const selectedPaymentMethodForm = ref<PaymentMethodFormInstance | null>(null)

const isFormBusy = computed(
  () => selectedPaymentMethodForm.value?.isBusy ?? false,
)

defineExpose<PaymentFormExpose>({
  isFormBusy,
  methodFormInstance: selectedPaymentMethodForm,
})
</script>
